import { ConfigConstants } from '../config/config-constants';
import { TimeUtilities } from './time-utilities';

const minNumber = 100000;
const maxNumber = 1000000;
const precisionNumber = 7;

export class NumberUtilities {
    /**
     * Generates a random Number between @min and @max values.
     * This method is needed when generating the keys/timestamps for different business entities
     *
     * @param min
     * @param max
     */
    public static getRandomNumberBetweenMinAndMax(min: number = minNumber, max: number = maxNumber): number {
        return Math.floor(Math.random() * (Math.floor(max) - Math.ceil(min))) + Math.ceil(min);
    }

    /**
     * Transforms the value of the Math.random to a normalized Value - integer.
     * Decimals are being here ignored
     * The precision is the amount of digits which should be considered by the method.
     * e.g number 0.45673456324 with a precision of 3 would return 456
     *
     * @param precision
     */
    public static getNormalizedRandomNumber(precision: number = precisionNumber): number {
        const decimalBase = 10;
        return Math.floor(Math.random() * Math.pow(decimalBase, precision));
    }

    public static convertToNumber(value: string | number | Date): number {
        if (typeof value === 'string') {
            return ConfigConstants.validationParser.Decimal(value);
        } else if (value instanceof Date) {
            const dateAndTime = TimeUtilities.momentFromDateAndTime(value.toDateString(), '');
            const formattedValue = dateAndTime.format(ConfigConstants.formatPatternDateGeneric);

            return ConfigConstants.validationParser.Decimal(formattedValue);
        } else {
            return value;
        }
    }
}
